// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2GS-d","iconContainer":"style_iconContainer__1wrl7","textContainer":"style_textContainer__2-8qW"};